import Menu from "./Menu";
import "./MasterPage.scss";
import Header from "./Header";
import PageError from "pages/Error/PageError";
import { Toaster } from "react-hot-toast";

interface ParamsMasterPage{
  children?: any
}

export default function MasterPage({children}:ParamsMasterPage){
  function renderChildren(){
    try {
      return children || "";
    } catch (error) {
      return <PageError/>
    }
  }
  
  return <div id="masterpage">
    <Header/>
    <Menu/>
    <div id="masterpage-contentpage">
      {renderChildren()}
    </div>
    <Toaster />
  </div>;
}